import { render, staticRenderFns } from "./AccountDomainLeaveOtherAccount.vue?vue&type=template&id=5339a4d4&"
import script from "./AccountDomainLeaveOtherAccount.vue?vue&type=script&lang=ts&"
export * from "./AccountDomainLeaveOtherAccount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports